import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // Use useNavigate instead of useHistory
import './Home.css'; // Import your CSS file for the slideshow
import homeImage1 from '../assets/images/home-image-1.jpg';
// import homeImage2 from '../assets/home-image-2.png';
// Images for the slideshow
const images = [
   { src: homeImage1, text: '' }
  // { src: homeImage2, text: '' }
];

const Home = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isLastImage, setIsLastImage] = useState(false); // Track if it's the last image
  const navigate = useNavigate(); // Initialize useNavigate

  useEffect(() => {
    // Transition to the next image every 2 seconds
    const interval = setInterval(() => {
      if (currentImageIndex < images.length - 1) {
        setCurrentImageIndex((prevIndex) => prevIndex + 1);
      } else {
        setIsLastImage(true); // Set to true when we reach the last image
      }
    }, 2000); // Change image every 2 seconds

    return () => clearInterval(interval); // Clean up the interval on component unmount
  }, [currentImageIndex]);

  useEffect(() => {
    if (isLastImage) {
      // Once the last image is shown, navigate to the map page
      setTimeout(() => {
        navigate('/map');
      }, 2000); // Wait for the last image to be visible before navigating
    }
  }, [isLastImage, navigate]);

  const handleClick = () => {
    navigate('/map'); // Navigate to the map page on click
  };

  return (
    <div>
      {/* Full-screen image slideshow */}
      <div className="home-container" onClick={handleClick}>
        <div
          className="home-image"
          style={{
            backgroundImage: `url(${images[currentImageIndex].src})`,
          }}
        >
          <div className="overlay-text">
            <h1>{images[currentImageIndex].text}</h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
